import { driveExtrasThemes, Theme } from './theme'

// driveExtrasThemes (theme.ts) are the only themes whose extras step renders
// DriveOptions, i.e. the only place bed & breakfast can be ticked. Flexible
// rebooking is offered on other themes too, so it is not gated here.
export const offersDriveExtras = (theme: Theme) =>
  driveExtrasThemes.includes(theme)

// Request field for bed & breakfast, the one drive-only extra. A stale `true`
// saved in the browser for another theme is never sent (#206).
export function driveExtrasRequestFields(order: {
  theme: Theme
  bedAndBreakfast: boolean
}) {
  return {
    bed_and_breakfast: offersDriveExtras(order.theme) && order.bedAndBreakfast,
  }
}
